import { createFileRoute } from "@tanstack/react-router";
import { preloadSourcingWebsite } from "@/pages/admin-sourcing-website-detail/api/fetch-sourcing-website-query";
import { searchParams } from "@/pages/admin-sourcing-website-detail/model/search-params";
import { SourcingWebsiteDetailPage } from "@/pages/admin-sourcing-website-detail/ui/sourcing-website-detail-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/sourcing/websites/$websiteId",
)({
  component: SourcingWebsiteDetailPage,
  loader: ({ params }) => preloadSourcingWebsite(params.websiteId),
  validateSearch: searchParams,
});
